import React from "react";
import { shallowEqual } from "react-redux";

import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { AllStopsCircleMarkers } from "./StopPunctualityReportMapModal";
import { setRouteMapRange } from "../../redux/actions";
import { calculateMaxExtents } from "../../utils/helpers";

const AllStopsPunctualityReportMap = (): JSX.Element => {
  const dispatch: Dispatch = useAppDispatch();

  const [allStopsArrayFiltered]: [StopInfo[]] = useAppSelector(
    (state: RootState) => [state?.routesInfo?.allStopsArrayFiltered],
    shallowEqual
  );

  React.useEffect(() => {
    if (allStopsArrayFiltered) {
      const maxExtents: Extent = calculateMaxExtents(allStopsArrayFiltered, 0.01);

      const corner1 = {
        lat: maxExtents?.minLat as number,
        lng: maxExtents?.minLon as number,
      } as LanLngPoint;
      const corner2 = {
        lat: maxExtents?.maxLat as number,
        lng: maxExtents?.maxLon as number,
      } as LanLngPoint;

      const bounds: LanLngPoint[] = [corner1, corner2];

      setTimeout(() => {
        // console.log("maxExtents:", maxExtents);
        //* V1
        // leafletMap.fitBounds(
        //   [
        //     [maxExtents?.minLat, maxExtents?.minLon],
        //     [maxExtents?.maxLat, maxExtents?.maxLon],
        //   ],
        //   {
        //     padding: [0, 0],
        //   }
        // );

        //* V2
        dispatch(setRouteMapRange(bounds as { lat: number; lng: number }[]));
      }, 500);
    }
  }, [allStopsArrayFiltered, dispatch]);

  return (
    <React.Fragment>
      {allStopsArrayFiltered ? <AllStopsCircleMarkers allStopsArrayFiltered={allStopsArrayFiltered} /> : null}
    </React.Fragment>
  );
};

export default AllStopsPunctualityReportMap;
